import EnhancedTabs from '@common/components/Tab/EnhancedTabs'
import { CurrentActiveTabProvider } from '@common/context/CurrentActiveTabProvider'
import { QC_TASK_LIST_TABS, QCTaskListTabsKey } from '@qc_task_list_view/constant'
import { TabOptionalComponentProvider } from '@common/context/TabOptionalComponentProvider'
import { TabConfig } from '@common/components/Tab/tabs.types'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { QcTaskSearchProvider } from '@qc_task_list_view/context/QcTaskSearchContext'
import { useCallback, useState } from 'react'
import { Box, Stack } from '@mui/material'
import QcTaskListTableToolbar from '@qc_task_list_view/components/QcTaskListTableToolbar'
import { SPACING } from '@common/theme/spacing'

export default function QcTaskListTabs() {
  const { hasPermission } = useCombinedPermissions()

  const [searchValue, setSearchValue] = useState<string>('')

  const handleSearch = useCallback((value: string) => {
    setSearchValue(value)
  }, [])

  const filteredTabs = Object.entries(QC_TASK_LIST_TABS).reduce(
    (acc, [key, tab]) => {
      if (!tab.permission || hasPermission(tab.permission)) {
        acc[key as QCTaskListTabsKey] = tab
      }
      return acc
    },
    {} as Record<QCTaskListTabsKey, TabConfig>,
  )

  return (
    <QcTaskSearchProvider value={{ searchValue, setSearchValue }}>
      <Stack spacing={SPACING.spacingMd}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <QcTaskListTableToolbar onSearch={handleSearch} searchValue={searchValue} />
        </Box>
        <CurrentActiveTabProvider>
          <TabOptionalComponentProvider>
            {Object.keys(filteredTabs).length > 0 && <EnhancedTabs tabs={filteredTabs} />}
          </TabOptionalComponentProvider>
        </CurrentActiveTabProvider>
      </Stack>
    </QcTaskSearchProvider>
  )
}
